import React from 'react';
export function App() {
  return <div className="bg-white font-sans" data-id="element-0">
      {/* Main Container */}
      <div className="max-w-4xl mx-auto bg-white" data-id="element-1">
        {/* Header - Removed PERLA BEAUTY text as requested */}
        <header className="text-center py-4 border-b border-gray-200" data-id="element-2">
          {/* Header content removed */}
        </header>
        {/* Hero Section */}
        <section className="py-8 px-4" data-id="element-3">
          <h1 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-4">
            "Persino il suo dermatologo pensava avesse 20 anni di meno"
          </h1>
          <p className="text-lg md:text-xl text-center text-gray-700 mb-6" data-id="element-5">
            Vogliono che tu spenda centinaia di euro in prodotti cosmetici
            inutili quando questo 1 ingrediente naturale è tutto ciò di cui hai
            bisogno...
          </p>
          {/* Woman image - Single column layout */}
          <div className="max-w-xl mx-auto mb-8" data-id="element-6">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1bz1ocASyVB6jWp6gNGMHx/1693477524963_vibriance_hero.webp" alt="Donna con pelle giovane" className="mx-auto max-w-full h-auto rounded-lg mb-8" data-id="element-7" />
            <p className="text-xl md:text-2xl font-semibold text-center text-gray-800 mb-8" data-id="element-8">
              Solo 1 prodotto elimina occhiaie, borse, zampe di gallina, pelle
              cadente e molto altro...
            </p>
          </div>
          {/* Testimonials in horizontal layout */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-9">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-10">
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-11">
                Il miglior prodotto di sempre!
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-12">
                "Uso il Siero Perla Eyes da quando è stato lanciato e ho
                iniziato a condividerlo con mia nuora. Entrambe lo adoriamo per
                la pelle luminosa e sana che ci dona. Ricevo spesso complimenti
                sulla mia pelle bellissima."
              </p>
              <p className="text-gray-600 font-medium" data-id="element-13">
                Maria S. Milano, Italia
              </p>
              <div className="flex mt-2" data-id="element-14">
                {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-15">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-16"></path>
                  </svg>)}
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-17">
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-18">
                Prodotto meraviglioso!
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-19">
                "Fantastico dal primo giorno! Texture setosa e risultati
                meravigliosi. Il mio contorno occhi è più liscio e le mie
                occhiaie si sono schiarite visibilmente. Lo consiglio
                vivamente!"
              </p>
              <p className="text-gray-600 font-medium" data-id="element-20">
                Giulia F. Roma, Italia
              </p>
              <div className="flex mt-2" data-id="element-21">
                {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-22">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-23"></path>
                  </svg>)}
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-24">
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-25">
                L'unica crema occhi che ho mai usato!
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-26">
                "Uso questo siero da alcuni anni. Ricevo sempre molti
                complimenti e persino il mio dermatologo ha pensato che avessi
                20 anni in meno della mia età!"
              </p>
              <p className="text-gray-600 font-medium" data-id="element-27">
                Francesca R. Napoli, Italia
              </p>
              <div className="flex mt-2" data-id="element-28">
                {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-29">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-30"></path>
                  </svg>)}
              </div>
            </div>
          </div>
          {/* Text content in single column */}
          <div className="max-w-3xl mx-auto mb-12" data-id="element-31">
            <p className="text-lg text-gray-700 mb-4" data-id="element-32">
              Donne, sto per condividere con voi la verità sulla cura del
              contorno occhi che i dermatologi conoscono da anni...
            </p>
            <p className="text-lg text-gray-700 mb-4" data-id="element-33">
              La skincare non dovrebbe essere complicata!
            </p>
            <p className="text-lg text-gray-700 mb-4" data-id="element-34">
              I progressi nella moderna scienza della pelle hanno reso possibile
              ottenere risultati migliori senza dover ricorrere a procedure
              dolorose e costose dal medico.
            </p>
            <p className="text-lg text-gray-700 mb-8" data-id="element-35">
              Un nuovo prodotto chiamato Perla Eyes è stato recentemente
              presentato su importanti canali televisivi mostrando una semplice
              soluzione per donne over 40 che ha fornito risultati sorprendenti:
            </p>
            <div className="bg-white p-6 rounded-lg shadow-md mb-8" data-id="element-36">
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-37">
                Perché Perla Eyes è diverso
              </h3>
              <ul className="list-disc pl-5 space-y-2 text-gray-700" data-id="element-38">
                <li data-id="element-39">
                  Contiene polvere di perla per illuminare il tuo contorno occhi
                </li>
                <li data-id="element-40">
                  Mentre altri prodotti si fermano in superficie, Perla Eyes
                  aumenta fisicamente lo spessore della pelle perioculare da
                  0.5mm a 0.7mm
                </li>
                <li data-id="element-41">
                  Attiva il collagene 3 volte più rapidamente grazie alla
                  conchiolina
                </li>
                <li data-id="element-42">Ingredienti naturali di altissima qualità</li>
                <li data-id="element-43">Risultati visibili in pochi giorni</li>
                <li data-id="element-44">Adatto a tutti i tipi di pelle, anche le più sensibili</li>
                <li data-id="element-45">Senza parabeni, solfati o ingredienti nocivi</li>
                <li data-id="element-46">Testato dermatologicamente</li>
                <li data-id="element-47">Garanzia soddisfatti o rimborsati di 1 anno</li>
              </ul>
            </div>
          </div>
        </section>
        {/* Benefits Section - With fuchsia graphic and product image */}
        <section className="py-12 px-4" data-id="element-48">
          <div className="bg-fuchsia-600 py-4 px-6 rounded-lg mb-10" data-id="element-49">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-white" data-id="element-50">
              5 motivi per cui le donne over 50 sono ossessionate da questo
              "siero di bellezza"
            </h2>
          </div>
          {/* Product image added below the headline */}
          <div className="max-w-md mx-auto mb-10" data-id="element-51">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8amzHSgUcaGHGcGcdx7Po1/Screenshot_2025-06-29_alle_21.50.46.png" alt="Donna che applica il siero Perla Eyes sul viso" className="mx-auto max-w-full h-auto rounded-lg shadow-lg" data-id="element-52" />
          </div>
          <div className="max-w-3xl mx-auto" data-id="element-53">
            <div className="mb-8" data-id="element-54">
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-55">
                1. Riequilibra il pH della tua pelle.
              </h3>
              <p className="text-gray-700" data-id="element-56">
                La stanchezza e lo stress possono causare micro-infiammazioni
                croniche nella zona perioculare, portando a gonfiore,
                arrossamenti e occhiaie. Perla Eyes aiuta a riequilibrare
                l'ambiente cutaneo e a calmare la pelle sensibile del contorno
                occhi grazie all'azione del carbonato di calcio.
              </p>
            </div>
            <div className="mb-8" data-id="element-57">
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-58">
                2. Riduce l'aspetto delle occhiaie.
              </h3>
              <p className="text-gray-700" data-id="element-59">
                Le occhiaie sono causate da iperpigmentazione e accumulo di
                melanina. Perla Eyes contiene polvere di perla che inibisce la
                tirosinasi, riducendo visibilmente queste antiestetiche macchie
                scure.
              </p>
            </div>
            <div className="mb-8" data-id="element-60">
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-61">
                3. Riduce l'aspetto di rughe e borse.
              </h3>
              <p className="text-gray-700" data-id="element-62">
                Ogni settimana riceviamo innumerevoli recensioni da donne
                entusiaste per come il loro contorno occhi appare più liscio e
                la prima cosa che notano è una riduzione visibile delle linee
                sottili.
              </p>
            </div>
            <div className="mb-8" data-id="element-63">
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-64">
                4. Noterai risultati VELOCI.
              </h3>
              <p className="text-gray-700" data-id="element-65">
                Entro pochi giorni vedrai risultati evidenti. Poiché ti
                guarderai allo specchio spesso, consigliamo di scattare una foto
                "prima" così potrai presto ammirare la tua foto "dopo".
              </p>
              <p className="text-gray-700 mt-2 font-medium" data-id="element-66">
                Questo non è come la skincare normale.
              </p>
            </div>
            <div className="mb-8" data-id="element-67">
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-68">
                5. Illumina e rassoda la pelle.
              </h3>
              <p className="text-gray-700" data-id="element-69">
                Una delle prime cose che le donne realizzano dopo aver provato
                Perla Eyes è che dona al contorno occhi una luminosità sana. Lo
                noterai già dal primo utilizzo!
              </p>
              <p className="text-gray-700 mt-2" data-id="element-70">
                Potresti notare che le borse e la pelle cadente intorno agli
                occhi iniziano ad apparire visibilmente più toniche.
              </p>
            </div>
          </div>
        </section>
        {/* Product Section */}
        <section className="py-12 px-4 bg-gray-50" data-id="element-71">
          <div className="max-w-3xl mx-auto" data-id="element-72">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8" data-id="element-73">
              Cosa rende Perla Eyes così richiesto da esaurirsi in 2 giorni?
              (Ripetutamente!)
            </h2>
            {/* Immagine del flacone spostata qui */}
            <div className="mx-auto max-w-full mb-10" data-id="element-74">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ek5QcXYE2SGiFHTZiePWqo/ChatGPT_Image_Jun_29%2C_2025%2C_07_38_40_PM.png" alt="Perla Eyes Serum" className="mx-auto max-w-full h-auto rounded-lg shadow-lg" data-id="element-75" />
            </div>
            <div className="mb-8" data-id="element-76">
              <p className="text-gray-700 mb-4" data-id="element-77">
                Consultando chimici cosmetici, dermatologi ed esperti di
                bellezza, abbiamo ricercato cosa funzionava e cosa non
                funzionava nella cura del contorno occhi.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-78">
                Cercavamo di creare un prodotto all-in-one che potesse
                sostituire un armadietto pieno di creme, lozioni e sieri.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-79">
                Prima di tutto, abbiamo selezionato polvere di perla
                micronizzata di altissima qualità, ingrediente protagonista
                della tradizione cosmetica asiatica da millenni.
              </p>
              <div className="bg-fuchsia-50 border-l-4 border-fuchsia-500 p-4 rounded-r mb-4 italic" data-id="element-80">
                <p className="text-gray-700" data-id="element-81">
                  "Ci sono voluti circa 2 anni per perfezionare finalmente il
                  nostro prodotto di punta all-in-one, Perla Eyes, ma quando
                  finalmente ci siamo riusciti, come si dice, il resto è
                  storia."
                </p>
              </div>
              <p className="text-gray-700" data-id="element-82">
                Abbiamo poi aggiunto Acido Ialuronico per un'idratazione
                profonda e Acido Lipoico per la sua potente azione
                antiossidante, creando un siero multitasking delicato abbastanza
                per i tipi di pelle più sensibili, ma che fornisce risultati
                visibili.
              </p>
            </div>
            <p className="text-gray-700 text-center mb-6" data-id="element-83">
              Questo è un trattamento quotidiano a casa approvato dai
              dermatologi. Meriti di coccolare la tua pelle con i migliori
              ingredienti che natura e scienza hanno da offrire!
            </p>
          </div>
        </section>
        {/* How It Works Section */}
        <section className="py-12 px-4" data-id="element-84">
          <div className="max-w-3xl mx-auto" data-id="element-85">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-4" data-id="element-86">
              L'azione in tre fasi di Perla Eyes
            </h2>
            {/* Immagine del ciclo di cura spostata qui */}
            <div className="max-w-xl mx-auto mb-10" data-id="element-87">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fKmYFNk7rTXqFWZTQ45wyd/Lazione_in_tre_fasi_di_Perla_Eyes_-_visual_selection_%281%29.png" alt="Le tre fasi di azione di Perla Eyes" className="mx-auto max-w-full h-auto" data-id="element-88" />
            </div>
            <div className="mb-8" data-id="element-89">
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-90">
                Fase 1: Inibizione della tirosinasi – Meno melanina, occhiaie
                più chiare
              </h3>
              <p className="text-gray-700" data-id="element-91">
                Le occhiaie scure sono spesso causate da iperpigmentazione. La
                polvere di perla interviene alla radice bloccando l'enzima
                tirosinasi, chiave nella sintesi della melanina. Gli amminoacidi
                bioattivi e minerali come zinco e magnesio inibiscono l'attività
                tirosinasica, riducendo la formazione di pigmento scuro.
              </p>
            </div>
            <div className="mb-8" data-id="element-92">
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-93">
                Fase 2: Rigenerazione cellulare – Stimolo al turnover epidermico
              </h3>
              <p className="text-gray-700" data-id="element-94">
                La polvere di perla fornisce un boost naturale alla
                rigenerazione cutanea grazie ai suoi fattori di crescita e
                proteine uniche. Contiene conchiolina, simile al collagene
                umano, che stimola i fibroblasti a produrre nuovo collagene ed
                elastina.
              </p>
            </div>
            <div className="mb-8" data-id="element-95">
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-96">
                Fase 3: Equilibrio del pH e azione lenitiva anti-infiammatoria
              </h3>
              <p className="text-gray-700" data-id="element-97">
                Il carbonato di calcio della perla agisce da tampone naturale,
                mentre i minerali oligoelementi svolgono un ruolo antiossidante
                e antinfiammatorio, riducendo borse e arrossamenti.
              </p>
            </div>
          </div>
        </section>
        {/* Results Section */}
        <section className="py-12 px-4 bg-gray-50" data-id="element-98">
          <div className="max-w-3xl mx-auto" data-id="element-99">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8" data-id="element-100">
              Quando vedrai risultati visibili?
            </h2>
            <p className="text-gray-700 text-center mb-6" data-id="element-101">
              Da quando Perla Eyes è stato lanciato, oltre 50.000 donne hanno
              semplificato la loro routine skincare con il nostro siero.
            </p>
            <p className="text-gray-700 text-center font-medium mb-6" data-id="element-102">
              Entro pochi giorni vedrai risultati evidenti.
            </p>
            <p className="text-gray-700 text-center mb-10" data-id="element-103">
              Poiché ti guarderai allo specchio spesso, consiglio di scattare
              una foto "prima" così potrai presto ammirare la tua foto "dopo".
            </p>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-104">
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-105">
                Mettendolo alla prova (oh che sorpresa!)...
              </h3>
              {/* Immagine aggiunta qui */}
              <div className="mx-auto max-w-xs mb-6" data-id="element-106">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1zePxTxUHc9qkfDcCpPcWL/ChatGPT_Image_Jun_29%2C_2025%2C_06_13_06_PM.png" alt="Flacone di Perla Eyes tenuto in mano" className="mx-auto max-w-full h-auto rounded-lg" data-id="element-107" />
              </div>
              <p className="text-gray-700 mb-3" data-id="element-108">
                "È arrivato abbastanza rapidamente (entro pochi giorni
                lavorativi).
              </p>
              <p className="text-gray-700 mb-3" data-id="element-109">
                Ovviamente, è arrivato con alcuni altri prodotti che avevo
                ordinato ma avevo voglia di provare questo per primo.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-110">
                Avevo la sensazione che se questo non avesse funzionato, niente
                avrebbe funzionato.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-111">
                Così l'ho subito applicato sul contorno occhi. La texture era
                fantastica e si è assorbita subito nella pelle.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-112">
                Non era eccessivamente "oleosa" come tendono ad essere alcuni
                sieri, il che era ottimo.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-113">
                La mattina dopo quando mi sono svegliata non mi aspettavo
                davvero di vedere alcuna differenza.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-114">
                Il che andava bene, perché non l'ho vista.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-115">
                Dopotutto, niente funziona dopo un solo giorno. In effetti, non
                sarei stata sorpresa se ci fossero volute settimane per vedere
                una differenza (se l'avessi vista).
              </p>
              <p className="text-gray-700 mb-3" data-id="element-116">
                Ma ecco dove le cose si fanno interessanti. Perché che ci
                crediate o no, NON ci sono volute settimane.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-117">
                In effetti, non c'è voluta nemmeno una settimana. Il giorno dopo
                che mi sono svegliata dopo aver usato il siero ho notato che i
                miei occhi sembravano MOLTO meno stanchi.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-118">
                Erano un po' più luminosi e dall'aspetto più liscio.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-119">
                Ora non era niente di drastico, avevo ancora le borse e la pelle
                cadente, ma ho visto una differenza. Qualcosa che non vedevo da
                molto tempo.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-120">
                E questo dopo solo DUE giorni!
              </p>
              <p className="text-gray-700 mb-3" data-id="element-121">
                Così è quando ho iniziato a emozionarmi davvero. Ho sentito la
                speranza tornare per la prima volta dopo anni.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-122">
                Perché se ci sono voluti solo due giorni per vedere un
                cambiamento, immagina cosa potrebbe succedere dopo una settimana
                o due?
              </p>
              <p className="text-gray-700 mb-3" data-id="element-123">
                Beh, ti dirò cosa è successo.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-124">
                Le mie occhiaie scure sono SVANITE. La pelle cadente sotto i
                miei occhi era quasi SPARITA completamente.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-125">
                Onestamente non potevo crederci. Mi sentivo come se mi fosse
                stata data una seconda possibilità nella vita.
              </p>
              <p className="text-gray-700 font-medium mb-3" data-id="element-126">
                "Ricevo sempre molti complimenti da sconosciuti e persino dal
                mio dermatologo che ha pensato che avessi 20 anni in meno della
                mia età prima di guardare la mia cartella."
              </p>
              <p className="text-gray-700 mb-3" data-id="element-127">
                "Perché mi ha davvero fatto sembrare vent'anni più giovane e
                molto meno stanca.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-128">
                Anche la mia famiglia e i miei amici se ne sono accorti.
                Pensavano che finalmente stessi dormendo bene...
              </p>
              <p className="text-gray-700 mb-3" data-id="element-129">
                Il che ovviamente non c'entrava nulla.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-130">
                Ma il fatto che nessuno mi dicesse più quanto sembravo stanca
                era già una ricompensa di per sé.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-131">
                Non potevo fare a meno di sorridere ogni volta che mi guardavo
                allo specchio. Era come guardare attraverso una macchina del
                tempo.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-132">
                Lo so, sembra una favola. Ancora non ci credo davvero nemmeno
                io.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-133">
                Avanti veloce fino a mentre scrivo questo, e uso ancora questo
                siero sui miei occhi e sul viso ogni singolo giorno.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-134">
                Perché non solo ha reso i miei occhi stupendi, ma ha
                completamente ringiovanito anche il mio viso.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-135">
                Due piccole macchie scure che avevo sulla guancia sono
                svanite...
              </p>
              <p className="text-gray-700 mb-3" data-id="element-136">
                Una ruga profonda che avevo sotto l'occhio sinistro sembra MOLTO
                meno evidente..."
              </p>
              <p className="text-gray-700 font-medium mb-3" data-id="element-137">
                "E la mia autostima è ai massimi storici! Mi sento di nuovo me
                stessa!"
              </p>
              <p className="text-gray-700 mb-3" data-id="element-138">
                "Ma questo è davvero autentico.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-139">
                Quindi sorge la domanda, funzionerà per TE? Ad essere onesta,
                non posso dire con certezza al 100% che lo farà.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-140">
                Ma se hai lottato con quelle terribili borse sotto gli occhi e
                pelle cadente per molto tempo e NIENTE altro ha funzionato, ti
                consiglio vivamente di provarlo.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-141">
                Ha completamente cambiato la mia vita e non sono l'unica.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-142">
                Quindi fai un favore a te stessa e provalo. Anche se sei piena
                di scetticismo sul fatto che possa davvero funzionare.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-143">
                Non hai idea di quanta differenza possa fare qualcosa di così
                piccolo e semplice.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-144">
                Inoltre, VOGLIONO che tu ottenga risultati, o non paghi. Quindi
                non c'è NIENTE da perdere."
              </p>
            </div>
          </div>
        </section>
        {/* More Testimonials Section */}
        <section className="py-12 px-4" data-id="element-145">
          <div className="max-w-3xl mx-auto" data-id="element-146">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-147">
              Cosa dicono le altre donne di Perla Eyes?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-148">
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-149">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-150">
                  Il miglior siero di sempre! ⭐⭐⭐⭐⭐
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-151">
                  "Dopo aver provato così tanti sieri ero riluttante a provare
                  Perla Eyes ma era conveniente quindi ci ho provato. Oh mio
                  Dio! Questo è il migliore di sempre! Il mio contorno occhi si
                  sente così idratato e vibrante!"
                </p>
                <p className="text-gray-600 font-medium" data-id="element-152">
                  DIANA S. | Acquirente Verificato
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-153">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-154">
                  Il meglio del meglio. ⭐⭐⭐⭐⭐
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-155">
                  "Il meglio del meglio. Tutto quello che so è che ho speso così
                  tanti soldi in prodotti per mantenere la mia pelle bella.
                  Questo è senza dubbio il miglior prodotto che abbia mai
                  usato."
                </p>
                <p className="text-gray-600 font-medium" data-id="element-156">
                  MONICA T. | Acquirente Verificato
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-157">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-158">
                  Luminosa con la perla ⭐⭐⭐⭐⭐
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-159">
                  "Molto felice dell'efficacia di questo prodotto e della
                  facilità d'uso. Non vedo l'ora della sua leggera fragranza
                  ogni mattina. La mia pelle è molto felice!"
                </p>
                <p className="text-gray-600 font-medium" data-id="element-160">
                  Susanna S. | Acquirente Verificato
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Purchase Section */}
        <section className="py-12 px-4 bg-gray-50" data-id="element-161">
          <div className="max-w-3xl mx-auto text-center" data-id="element-162">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-163">
              Dove posso acquistare Perla Eyes?
            </h2>
            {/* Immagine spostata qui */}
            <div className="mx-auto max-w-full mb-8" data-id="element-164">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8HLvwgHY2dxa4qsFuKA2Ne/ChatGPT_Image_May_16%2C_2025%2C_07_35_12_PM.png" alt="Perla Eyes Serum Bottle su vassoio con post-it" className="mx-auto max-w-full h-auto rounded-lg shadow-lg" data-id="element-165" />
            </div>
            <p className="text-lg text-gray-700 mb-6" data-id="element-166">
              Puoi acquistare Perla Eyes al MIGLIOR PREZZO direttamente dal
              nostro sito web.
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-167">
              Attualmente abbiamo una Promozione Speciale: I Nuovi Clienti
              Ottengono Fino al 37% di Sconto e Spedizione GRATUITA!
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-168">
              E non preoccuparti, questo è un ordine una tantum. NON è un
              abbonamento.
            </p>
            <p className="text-lg text-gray-700 mb-10" data-id="element-169">
              Tutti gli ordini sono coperti dalla nostra garanzia soddisfatti o
              rimborsati di 1 anno "fino all'ultima goccia".
            </p>
            <div className="mb-10" data-id="element-170">
              <a href="https://perlabeauty.it/perla-eyes" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-full text-xl shadow-lg transition duration-300 ease-in-out transform hover:scale-105 inline-block" data-id="element-171">
                APPLICA LO SCONTO E VERIFICA LA DISPONIBILITÀ
              </a>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-left mb-10" data-id="element-172">
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-173">
                Per quanto tempo ancora lotterai con prodotti costosi e
                inefficaci?
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-174">
                Perla Eyes ti fornisce ingredienti reali, naturali e sicuri che
                sono clinicamente dimostrati per schiarire le occhiaie, ridurre
                borse e rughe e donare alla tua pelle una luminosità radiosa...
                senza procedure, sostanze chimiche dannose o tattiche
                ingannevoli.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-175">
                Perla Eyes vuole fornirti risultati reali... a una frazione del
                costo...
              </p>
              <p className="text-gray-700" data-id="element-176">
                Così non devi continuare a cercare all'infinito prodotti
                skincare che non funzionano, o peggio, sono DANNOSI per la tua
                pelle.
              </p>
            </div>
            <p className="text-lg text-gray-700 mb-6" data-id="element-177">
              In parole semplici, amerai Perla Eyes o ti restituiremo i tuoi
              soldi, senza fare domande! (Anche se usi l'intera bottiglia!)
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-178">
              Puoi provare Perla Eyes completamente senza rischi!
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-179">
              Ciò significa che se non sei soddisfatta al 100% del tuo acquisto,
              Perla Eyes ti restituirà il tuo investimento... ogni singolo
              centesimo... senza rancore.
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-180">
              NESSUN problema. NESSUN fastidioso ostacolo da superare. NESSUNA
              domanda.
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-181">
              Sappiamo che la probabilità che ciò accada è bassa... e questo
              perché abbiamo trascorso gli ultimi anni a perfezionare la nostra
              formula ispirata alla tradizione cosmetica asiatica.
            </p>
            <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-182">
              Cosa significa questo per te?
            </h3>
            <p className="text-lg text-gray-700 mb-10" data-id="element-183">
              Significa che stai ottenendo il prodotto di migliore qualità per
              aiutare a schiarire le tue occhiaie e illuminare il tuo contorno
              occhi in modo completamente NATURALE e SICURO.
            </p>
            <p className="text-lg text-gray-700 mb-10" data-id="element-184">
              Siamo così sicuri che il nostro siero sia la soluzione che stavi
              cercando, che se non sei soddisfatta al 110%, allora ti
              restituiremo i tuoi soldi.
            </p>
            <div className="mb-10" data-id="element-185">
              <a href="https://perlabeauty.it/perla-eyes" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-full text-xl shadow-lg transition duration-300 ease-in-out transform hover:scale-105 inline-block" data-id="element-186">
                PROVA PERLA EYES ORA &gt;&gt;
              </a>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-left mb-10" data-id="element-187">
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-188">
                Il modo in cui la vediamo - hai davvero 2 opzioni...
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-189">
                L'opzione #1 è lasciare questo sito web, non ordinare Perla
                Eyes, e continuare a usare i soliti vecchi prodotti skincare.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-190">
                Puoi andare a comprare uno di quei costosi prodotti di marca
                venduti da grandi marchi di moda che mettono solo il loro nome
                su qualche prodotto skincare generico.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-191">
                Oppure puoi provare l'Opzione #2.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-192">
                E cioè semplicemente fare ciò che oltre 50.000 donne over 50
                hanno fatto prima di te e provare Perla Eyes completamente senza
                rischi.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-193">
                Non è una coincidenza che tu abbia dedicato del tempo su questa
                pagina arrivando fino in fondo.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-194">
                Significa che sei pronta a provare qualcosa di nuovo.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-195">
                Ecco perché ti chiedo di fidarti di te stessa nel prendere la
                decisione giusta.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-196">
                Quando confronti queste due opzioni per te stessa.
              </p>
              <p className="text-gray-700" data-id="element-197">
                È facile vedere quanto abbia senso...
              </p>
            </div>
            <p className="text-lg text-gray-700 mb-6" data-id="element-198">
              Quindi vai avanti e clicca sul pulsante verde in questa pagina qui
              sotto per selezionare il tuo pacchetto di Perla Eyes.
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-199">
              Ma ricorda, questa offerta speciale per risparmiare fino al 37% di
              sconto è disponibile solo per le persone che agiscono su questa
              pagina qui oggi.
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-200">
              Se lasci questa pagina, Perla Eyes sarà disponibile solo sul
              nostro sito web al suo prezzo normale, che è quasi il doppio di
              quello che puoi acquistare oggi.
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-201">
              E non dimenticare, puoi provare Perla Eyes completamente senza
              rischi.
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-202">
              Usa l'intera bottiglia, se per qualsiasi motivo non sei
              soddisfatta dei risultati - hai fino a un anno intero per ottenere
              un rimborso completo dei tuoi soldi.
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-203">
              Non vediamo l'ora di sentire della tua esperienza con Perla Eyes.
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-204">
              I tuoi risultati dopo 1 settimana, 4 settimane e oltre.
            </p>
            <p className="text-lg text-gray-700 mb-10" data-id="element-205">
              Vorrai scattare una foto prima e dopo!
            </p>
            <p className="text-lg text-gray-700 mb-2" data-id="element-206">
              Le tue partner in bellezza,
            </p>
            <p className="text-xl font-bold text-gray-800 mb-10" data-id="element-207">Perla Eyes</p>
            <div className="mb-10" data-id="element-208">
              <a href="https://perlabeauty.it/perla-eyes" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-full text-xl shadow-lg transition duration-300 ease-in-out transform hover:scale-105 inline-block" data-id="element-209">
                PROVA PERLA EYES ORA &gt;&gt;
              </a>
            </div>
          </div>
        </section>
        {/* Footer */}
        <footer className="py-6 px-4 bg-gray-800 text-white text-center" data-id="element-210">
          <p className="text-sm" data-id="element-211">
            © {new Date().getFullYear()} Perla Beauty. Tutti i diritti
            riservati.
          </p>
        </footer>
      </div>
    </div>;
}